<template>
  <div class="created-dialog-modal">
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('lightserver.instance.createSnapshotDialog.header')"
      :visible="visible"
      width="730px"
      :before-close="handleClose"
    >
      <div class="alert-box">
        <p><i class="el-icon-warning-outline"></i> <strong>{{ $t('lightserver.instance.createSnapshotDialog.noteList.tag') }}</strong></p>
        <ul>
          <li>{{ $t('lightserver.instance.createSnapshotDialog.noteList.first') }}</li>
          <li>{{ $t('lightserver.instance.createSnapshotDialog.noteList.second') }}</li>
        </ul>
      </div>
      <el-form :model="form" label-position="right" label-width="140px">
        <el-form-item :label="$t('lightserver.instance.createSnapshotDialog.columnList.name')">
          {{ form.ins_tag }}
        </el-form-item>
        <el-form-item :label="$t('lightserver.instance.createSnapshotDialog.columnList.package')">
          {{ form.ins_desc }}
        </el-form-item>
        <el-form-item :label="$t('lightserver.instance.createSnapshotDialog.columnList.diskCapacity')">
          {{ form.sysdisk }}GB
        </el-form-item>
        <el-form-item :label="$t('lightserver.instance.createSnapshotDialog.columnList.snapshotName')">
          <el-input
            :placeholder="$t('lightserver.instance.createSnapshotDialog.columnList.snapshotPlaceholder')"
            v-model="name"
          ></el-input>
          <p class="input-tips">{{$t('lightserver.instance.createSnapshotDialog.columnList.snapshotTag')}}</p>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{$t('lightserver.instance.createSnapshotDialog.buttons.cancel')}}</el-button>
        <el-button type="primary" :disabled="buttonDisabled" @click="create()">{{$t('lightserver.instance.createSnapshotDialog.buttons.done')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      form: {},
      name: "",
      code: "",
      buttonDisabled: false,
    };
  },
  watch: {
    visible: {
      handler(n, o) {
        this.visible = n;
        if (!n) {
          this.init();
        }
      },
    },
    form: {
      handler(n, o) {
        
      },
      immediate: true,
      deep: true,
    },
  },
  props: {},
  methods: {
    init() {
      Object.assign(this.$data, this.$options.data());
    },
    handleClose() {
      this.visible = false;
    },

    showChange() {
      this.visible = !this.visible;
    },
    async create() {
        this.buttonDisabled = true;
      let obj = {
        stores: [this.form.sn],
        name: this.name,
        instanceId: this.form.instance_sn,
      };
      if (this.name == '') {
        this.$message.error(this.$t('lightserver.instance.createSnapshotDialog.error.err1'));
        return;
      }
      if (this.name.length < 2 || this.name.length > 60) {
        this.$message.error(this.$t('lightserver.instance.createSnapshotDialog.error.err2'));
        return;
      }
      let {
        data: {code, message, data},
      } = await this.$http.post("/lightserver/instances/addSnapshot", obj);
      this.buttonDisabled = false;
      if (code == 0) {
        this.$message.success(message);
        this.visible = !this.visible;
        location.reload();
      } else {
        this.$message.error(message);
      }

    },
  },
};
</script>

<style scoped lang="scss">
.info-item {
  margin-bottom: 0px;
}
.alert-box {
  background: rgba(51, 119, 255, 0.1);
  padding: 16px;
  font-size: 14px;
  line-height: 22px;
  color: #3377ff;
  margin-bottom: 32px;
  p {
    margin-bottom: 12px;
    i {
      font-weight: bold;
    }
  }
  ul {
    li {
      list-style-type: decimal;
      list-style-position: inside;
      margin-bottom: 12px;
      word-break: keep-all;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.input-tips {
  color: #acb4bf;
  font-size: 14px;
  line-height: 20px;
  margin-top: 6px;
}
.codewrap {
  display: flex;
  .el-input {
    flex: 1;
    height: 40px;
    margin-right: 16px;
  }
  button {
    flex-shrink: 0;
    min-width: 188px;
    height: 40px;
    background: #eff4ff;
    font-size: 14px;
    font-weight: 500;
    padding: 0 16px;
    color: #3377ff;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lightServer/CreateSnapshot.vue